export default __webpack_public_path__ + "static/media/connectStripe.cb07c6a8.svg";